import { render, staticRenderFns } from "./DashboardQuickLearn.vue?vue&type=template&id=5c6573ce&scoped=true&"
import script from "./DashboardQuickLearn.vue?vue&type=script&lang=js&"
export * from "./DashboardQuickLearn.vue?vue&type=script&lang=js&"
import style0 from "./DashboardQuickLearn.vue?vue&type=style&index=0&id=5c6573ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6573ce",
  null
  
)

export default component.exports